import { useCallback } from "react";
import { IPanelHomologacion } from "../../../../Interfaces/auxiliar/IOperador";
import { UsePanelHomologar } from "./UsePanelHomologar";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
import { TextField } from "@fluentui/react";
import { PanelDrawer } from "../../../../components/Panel/PanelDrawer";



export const PanelHomologar=(props:IPanelHomologacion)=>{
    const {mensaje,status,loading,request,setRequest,reset,postCrearPersona} = UsePanelHomologar(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Editar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={postCrearPersona}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [request]
      );
    return (
        <PanelDrawer isOpen={props.isOpen} onDismiss={reset} textHeader={"Operador"} subTextHeader="Homologar Operador" 
        status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
            <TextField
            type="text" label="Código Dispatch"
            readOnly borderless
            value={props.operador.codigoSync}/>
            <TextField
            type="text" label="Nombre Dispatch"
            readOnly borderless
            value={props.operador.operador}/>
            <TextField
            type="text" label="Código SAP"
            value={request.codigoRRHH} 
            onChange={(event, newValue) => {
            if (newValue != null) {
                setRequest({
                ...request, codigoRRHH: newValue,
                tipoDocumentoIdentidad: "DNI"
                })
            }}}/>
            <TextField
            type="text" label="Primer Nombre"
            value={request.primerNombre} 
            onChange={(event, newValue) => {
            if (newValue != null) {
                setRequest({
                ...request, primerNombre: newValue,
                tipoDocumentoIdentidad: "DNI"
                })
            }}}/>
            <TextField
            type="text" label="Segundo Nombre"
            value={request.segundoNombre} 
            onChange={(event, newValue) => {
            if (newValue != null) {
                setRequest({
                ...request, segundoNombre: newValue,
                tipoDocumentoIdentidad: "DNI"
                })
            }}}/>
            <TextField
            type="text" label="Apellido Paterno"
            value={request.apellidoPaterno} 
            onChange={(event, newValue) => {
            if (newValue != null) {
                setRequest({
                ...request, apellidoPaterno: newValue,
                tipoDocumentoIdentidad: "DNI"
                })
            }}}/>
            <TextField
            type="text" label="Apellido Materno"
            value={request.apellidoMaterno} 
            onChange={(event, newValue) => {
            if (newValue != null) {
                setRequest({
                ...request, apellidoMaterno: newValue,
                tipoDocumentoIdentidad: "DNI"
                })
            }}}/>

        </PanelDrawer>
   )
}